/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from '@/shared/api/axios-client'
import type {
  GetUserRequestsByExternalIdWatchdocsUserRequestIdQueryResponse,
  GetUserRequestsByExternalIdWatchdocsUserRequestIdPathParams,
  GetUserRequestsByExternalIdWatchdocsUserRequestId400,
} from '../entities/GetUserRequestsByExternalIdWatchdocsUserRequestId'
import type { RequestConfig, ResponseErrorConfig } from '@/shared/api/axios-client'

function getGetUserRequestsByExternalIdWatchdocsUserRequestIdUrl(
  watchdocs_user_request_id: GetUserRequestsByExternalIdWatchdocsUserRequestIdPathParams['watchdocs_user_request_id'],
) {
  return `/user-requests/by-external-id/${watchdocs_user_request_id}` as const
}

/**
 * @description Получение заявки водителя таксопарка по внешнему ID
 * @summary Получение заявки водителя таксопарка по внешнему ID
 * {@link /user-requests/by-external-id/:watchdocs_user_request_id}
 */
export async function getUserRequestsByExternalIdWatchdocsUserRequestId(
  watchdocs_user_request_id: GetUserRequestsByExternalIdWatchdocsUserRequestIdPathParams['watchdocs_user_request_id'],
  config: Partial<RequestConfig> & { client?: typeof client } = {},
) {
  const { client: request = client, ...requestConfig } = config

  const res = await request<
    GetUserRequestsByExternalIdWatchdocsUserRequestIdQueryResponse,
    ResponseErrorConfig<GetUserRequestsByExternalIdWatchdocsUserRequestId400>,
    unknown
  >({ method: 'GET', url: getGetUserRequestsByExternalIdWatchdocsUserRequestIdUrl(watchdocs_user_request_id).toString(), ...requestConfig })
  return res.data
}